import { useEffect, useRef, useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { getEmailThemePayload } from '@/configuration/pages/ConfigurationPage/CommunicationsConfiguration/ThemesConfiguration/helpers'
import { configurationTypes } from '@/configuration/pages/ConfigurationPage/constants'
import { getConfigurationMode, getEntityIdByConfigurationMode } from '@/configuration/pages/ConfigurationPage/helpers'

import { servicesByConfigurationMode } from './constants'

const usePreview = ({
  colors,
  textStyles,
  linkColor,
  footerImage,
  merchantId,
  returnPortalId,
  templates,
  setToastInfo,
  isUnifiedDashboard,
  settingsType,
  language,
}) => {
  const [selectedTemplate, setSelectedTemplate] = useState(templates[0]?.id)

  const configMode = getConfigurationMode({ isUnifiedDashboard, settingsType })
  const services = servicesByConfigurationMode[configMode || configurationTypes.returnsPortal]
  const entityId = getEntityIdByConfigurationMode({
    configurationMode: configMode,
    merchantId,
    returnPortalId,
  })

  const {
    data: preview,
    loading: fetchingPreview,
    fetchData: fetchPreview,
  } = useFetch(services.getEmailThemePreview, {
    doInitialRequest: false,
  })

  const fetchPreviewRef = useRef(fetchPreview)
  const entityIdRef = useRef(entityId)
  const setToastInfoRef = useRef(setToastInfo)

  useEffect(() => {
    fetchPreviewRef.current = fetchPreview
  }, [fetchPreview])

  useEffect(() => {
    entityIdRef.current = entityId
  }, [entityId])

  useEffect(() => {
    setToastInfoRef.current = setToastInfo
  }, [setToastInfo])

  useEffect(() => {
    if (templates.length === 0) return

    const exists = templates.some(template => template.id === selectedTemplate)

    if (!exists) {
      setSelectedTemplate(templates[0].id)
    }
  }, [templates, selectedTemplate])

  useEffect(() => {
    if (!selectedTemplate) return

    const timeout = setTimeout(async () => {
      try {
        const payload = getEmailThemePayload({ colors, textStyles, linkColor, footerImage, language })
        payload.append('template_id', selectedTemplate)
        await fetchPreviewRef.current({ ...entityIdRef.current, payload })
      } catch (error) {
        setToastInfoRef.current({ show: true, message: error.errorMessage, type: 'error' })
      }
    }, 500)

    return () => clearTimeout(timeout)
  }, [colors, textStyles, linkColor, footerImage, selectedTemplate, language])

  const handleChangeTemplate = e => {
    setSelectedTemplate(e.target.value)
  }

  return { preview, fetchingPreview, selectedTemplate, setSelectedTemplate, handleChangeTemplate }
}

export default usePreview
